export function handlePhoneMask(phone: string) {
  const onlyNumbers = phone.replace(/\D/g, '');

  if (onlyNumbers.length > 10)
    return onlyNumbers.replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3');

  if (onlyNumbers.length === 10)
    return onlyNumbers.replace(/(\d{2})(\d{4})(\d{4})/g, '($1) $2-$3');

  if (onlyNumbers.length > 2)
    return onlyNumbers.replace(/(\d{2})(\d{0,7})/g, '($1) $2');

  return phone;
}
